import { publicPortalFetch, KyraApiError } from "./api";
import type { PublicPortalInfo } from "./types";

/**
 * SVG 1x1 transparente como fallback de favicon. Quando o trainer não tem
 * logo nem avatar, a aba fica com ícone genérico do browser em vez de
 * vazar uma marca "Kyra" (white-label puro).
 */
export const TRANSPARENT_FAVICON_DATA_URL =
  "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201%201%22%2F%3E";

/**
 * Resolve branding público do trainer a partir do slug do aluno. Fail-mode:
 * retorna null em qualquer erro pra o caller cair em fallback neutro
 * ("Portal do Aluno") em vez de quebrar a tela.
 */
export async function getBrandingForSlug(slug: string): Promise<PublicPortalInfo | null> {
  try {
    return await publicPortalFetch<PublicPortalInfo>(
      `/public-portal/portal-info/${encodeURIComponent(slug)}`,
    );
  } catch (err) {
    if (!(err instanceof KyraApiError)) {
      console.warn("[branding] getBrandingForSlug falhou", err);
    }
    return null;
  }
}

/** Preferência de favicon: logo_url > avatar_url > transparente. */
export function pickFaviconUrl(
  branding: { trainer: { logo_url: string | null; avatar_url: string | null } } | null,
): string {
  return (
    branding?.trainer.logo_url || branding?.trainer.avatar_url || TRANSPARENT_FAVICON_DATA_URL
  );
}

/** Aplica favicon + título no documento (white-label client-side). */
export function applyBrandingToDocument(branding: PublicPortalInfo | null): void {
  const faviconUrl = pickFaviconUrl(branding);
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;

  const trainerName = branding?.trainer.full_name?.trim();
  document.title = trainerName ? `${trainerName} — Portal do Aluno` : "Portal do Aluno";
}
